<nav class="header-container">
  <div class="header-title">
    <button
      type="button"
      mat-icon-button
      aria-label="Mostar u ocultar menu"
      (click)="togglLeftMenu()">
      <mat-icon class="flex" svgIcon="menu"></mat-icon>
    </button>
    @let info = siteInfo();
    <button (click)="goToSiteHome()">
      @if (info.logo) {
        <img [src]="info.logo" [alt]="info.name" class="ms-4 h-10" />
      } @else {
        <h5>{{ info.name }}</h5>
      }
    </button>
  </div>
  <div class="header-search">
    @if (canShowSearch()) {
      <edt-search
        class="z-50"
        (inputChanged)="doSearch($event)"
        (inputCleared)="doSearch()"
        (optionSelected)="optionSelected($event)"
        [placeHolder]="searchPlaceholder"
        [autoSearch]="autoSearch"
        [delayAutoSearchTime]="delayAutoSearchTime"
        [allowSuggestions]="allowSuggestions"
        [showHistory]="showHistory"
        [compact]="compactMode" />
    }
  </div>
  <div class="header-actions">
    <div class="cart-container">
      @let cartIcon = validCart() ? 'shopping_cart' : 'shopping_cart_warning';
      @if (resolvingCart()) {
        <mat-progress-spinner
          mode="indeterminate"
          diameter="20"
          strokeWidth="2">
        </mat-progress-spinner>
      } @else {
        <edt-badge
          (openedChange)="toggleCart($event)"
          [opened]="cartOpened()"
          [quantity]="quantity()">
          <mat-icon [svgIcon]="cartIcon"></mat-icon>
        </edt-badge>
      }
    </div>

    <div class="usermenu-container">
      <auth-user-menu
        [actions]="authUserMenu"
        [userInfo]="userInfo()"
        [notLoggedInIcon]="authUserButton()?.notLoggedInIcon ?? undefined"
        [notLoggedInText]="authUserButton()?.notLoggedInText ?? undefined"
        [loggedInIcon]="authUserButton()?.loggedInIcon ?? undefined"
        [loggedInText]="authUserButton()?.loggedInText ?? undefined"
        [userPanelCssClass]="authUserButton()?.userPanelCssClass ?? ''"
        [dropContentCssClass]="authUserButton()?.dropContentCssClass ?? ''"
        [dropItemCssClass]="authUserButton()?.dropItemCssClass ?? ''"
        userImage="assets/account-outline.svg"
        (action)="onActionDispached($event)" />
    </div>
  </div>
</nav>
